export default __webpack_public_path__ + "static/media/ClaraMusica.78964361.jpg";